import type { JourneyTransformed } from '~/types/Journey.types';

/**
 * If the incoming journey has `header_images: undefined`, treat that as
 * "not computed" and preserve the previously-stored header images. Any
 * other value (including `[]`) replaces the previous one. See
 * `TripTransformer` Strategy C.
 */
export function preserveHeaderImages(
  next: JourneyTransformed,
  previous: JourneyTransformed | null
): JourneyTransformed {
  if (next.header_images === undefined && previous) {
    return {
      ...next,
      header_images: previous.header_images,
      header_image: previous.header_image
    };
  }
  return next;
}
